import React from "react";
import { BookOpen } from "lucide-react";
import RoleScopedPlaceholder from "../../components/RoleScopedPlaceholder";

export default function PortalCoursesPage() {
  return <RoleScopedPlaceholder title="Courses" moduleKey="courses" icon={BookOpen} />;
}
